import * as Scrivito from "scrivito";
import defaultPageAttributes from "objs/_defaultPageAttributes";
import metadataAttributes from "objs/_metadataAttributes";

const TextImageSlide = Scrivito.provideObjClass("TextImageSlide", {
  attributes: {
    backgroundImage: ["reference", { only: ["Image"] }],
    body: "html",
    smallHeader: "string",
    sortKey: "integer",
    targetLink: "link",
    teaserText: "string",
    ...defaultPageAttributes,
    ...metadataAttributes,
  },
});

export default TextImageSlide;
